'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _url = require('../attributes/url');

var _query = require('../attributes/query');

var _headers = require('../attributes/headers');

var _credentials = require('../attributes/credentials');

var _mode = require('../attributes/mode');

var _body = require('../attributes/body');

var _Profile = require('../classes/Profile');

var _Profile2 = _interopRequireDefault(_Profile);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: Preparing the fetch attributes for execution
 * @param {String} url :: url string
 * @param {String} method :: fetch method [GET, PUT, POST, ...]
 * @param {String} profile :: profile key
 * @param {Array} headers :: Array of headers
 * @param {Array} query :: Array of queries
 * @param {any} body :: body of the fetch
 * @param {String} credentials :: credentials string
 * @param {String} mode :: mode string
 * @return {Object} :: Fetch attributes
 */


exports.default = function (_ref) {
  var url = _ref.url,
      method = _ref.method,
      profile = _ref.profile,
      headers = _ref.headers,
      query = _ref.query,
      body = _ref.body,
      credentials = _ref.credentials,
      mode = _ref.mode;

  var selectedProfile = _Profile2.default.getProfile(profile);

  var options = {
    method: method,
    headers: _headers.prepareHeaders.apply(undefined, (0, _toConsumableArray3.default)(selectedProfile.headers).concat((0, _toConsumableArray3.default)(headers)))
  };
  var preparedCredentials = (0, _credentials.prepareCredentials)(selectedProfile.credentials, credentials);
  if (preparedCredentials) options.credentials = preparedCredentials;
  var preparedMode = (0, _mode.prepareMode)(selectedProfile.mode, mode);
  if (preparedMode) options.mode = preparedMode;
  var preparedBody = (0, _body.prepareBody)(selectedProfile.body, body);
  if (preparedBody) options.body = preparedBody;
  return {
    url: (0, _url.prepareUrl)(selectedProfile.url, url, _query.prepareQuery.apply(undefined, (0, _toConsumableArray3.default)(selectedProfile.query).concat((0, _toConsumableArray3.default)(query)))),
    options: options,
    responder: selectedProfile.responder
  };
}; // Classes
// Attributes